<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
>



    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="search"
    >
        <template v-slot:append-outer>
            <div class="d-flex align-center">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on" class="mr-2 d-flex align-center" style="cursor: help">
                             <v-progress-circular
                                :value="(seconds_remaining / 15) * 100"
                                color="primary"
                                size="20"
                                width="2"
                                rotate="-90"
                                :indeterminate="loading"
                            >
                                <v-icon x-small color="primary">mdi-refresh</v-icon>
                            </v-progress-circular>
                        </div>
                    </template>
                    <span>Last updated: {{ last_updated || 'Never' }}</span><br>
                    <span>Refreshing in {{ seconds_remaining }}s</span>
                </v-tooltip>

                <v-menu
                    bottom
                    offset-y
                >
                    <template v-slot:activator="{ on }">
                        <v-icon
                            v-on="on"
                        >
                            mdi-dots-vertical
                        </v-icon>
                    </template>
            
                    <v-list>
                        <v-list-item
                            v-on:click="onRefresh()"
                        >
                            <v-list-item-title>Refresh</v-list-item-title>
                        </v-list-item>
                        
                        <!-- <v-list-item
                            v-on:click="onClickExport()"
                        >
                            <v-list-item-title>Export to Excel...</v-list-item-title>
                        </v-list-item> -->
                    </v-list>
                </v-menu> 
            </div>
        </template>
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :search="search"
        :item-class="itemRowBackground"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
        <template v-slot:item.sync_batch_type="{ item }">
            {{item.first_in_batch ? prettySyncType(item.sync_batch_type) : ''}}
        </template>

        <template v-slot:item.document_type="{ item }">
            {{prettyDocumentType(item.document_type)}}
        </template>
    
        <template v-slot:item.time_run_start_date="{ item }">
            {{$rc.pretty(item.time_run_start,'date')}}
        </template>
        <template v-slot:item.time_run_start_time="{ item }">
            {{$rc.pretty(item.time_run_start,'time')}}
        </template>
    
        <template v-slot:item.time_run_stop_date="{ item }">
            {{$rc.pretty(item.time_run_stop,'date')}}
        </template>
        <template v-slot:item.time_run_stop_time="{ item }">
            {{$rc.pretty(item.time_run_stop,'time')}}
        </template>
    
        <template v-slot:item.count_chunks_pending="{ item }">
            {{item.count_chunks_pending + item.count_chunks_ready_to_run}}
        </template>
    
        <template v-slot:item.count_document="{ item }">
            {{$rc.pretty(item.count_document,'int')}}
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu
                v-if="item.first_in_batch"
                bottom 
                offset-y  
            >
                <template v-slot:activator="{ on }">
                    <v-icon 
                        v-on="on"
                    >
                        mdi-dots-vertical-circle-outline
                    </v-icon>
                </template>

                <v-list>
                    <v-list-item
                        v-on:click="onClickViewChunkDetail(item)"
                    >
                        <v-list-item-title>View chunk detail...</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu> 
        </template>

    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {
    data() {
        return {
            search: '',
            headers: [
                { text: 'Sync Type', value: 'sync_batch_type'},
                { text: 'Document Type', value: 'document_type'},
                { text: 'Start (date)', value: 'time_run_start_date'},
                { text: 'Start (time)', value: 'time_run_start_time'},
                { text: 'Finish (date)', value: 'time_run_stop_date'},
                { text: 'Finish (time)', value: 'time_run_stop_time'},
                { text: 'Chunks Pending', value: 'count_chunks_pending'},
                { text: 'Chunks Succeeded', value: 'count_chunks_finished_success'},
                { text: 'Chunks Failed', value: 'count_chunks_finished_failed'},
                { text: 'Document Count', value: 'count_document'},
                { text: 'Action', value: 'action' },
            ],

            results: [],
            interval_id: null,
            poll_timeout_id: null,
            loading: false,
            last_updated: null,
            seconds_remaining: 15,
        }
    },

    mounted () {
        this.doUpdate();

        this.interval_id = setInterval(() => {
            this.seconds_remaining--;
            if (this.seconds_remaining <= 0) {
                this.doUpdate();
            }
        }, 1000);

        this.poll_timeout_id = setTimeout(() => {
            clearInterval(this.interval_id);
        }, 30 * 60 * 1000);
    },

    beforeDestroy() {
        clearInterval(this.interval_id);
        clearTimeout(this.poll_timeout_id);
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),

        doUpdate()
        {
            this.seconds_remaining = 15;
            this.loading = true;
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/integrations/:settings_id/sync-history',

                'params' : {
                    'organization_id': this.$route.params.organization_id,
                    'settings_id': this.$route.params.settings_id
                },

                'on_success': (data) => {
                        this.results = this.augment(data.results);
                        this.loading = false;
                        this.last_updated = new Date().toLocaleTimeString();
                    },

                'on_error': () => {
                        this.loading = false;
                    },
            });
        },

        augment(results)
        {
            let last_sync_batch_id = '';
            results.forEach(row => {
                row.first_in_batch = row.sync_batch_id != last_sync_batch_id;
                last_sync_batch_id = row.sync_batch_id;
            });

            return results;
        },

        itemRowBackground(item)
        {
            return item.first_in_batch ? 'font-weight-medium' : ''
        },

        prettySyncType(sync_batch_type)
        {
            return this.$rc.enumObject('crm_sync_type', sync_batch_type)?.text;
        },

        prettyDocumentType(document_type)
        {
            return this.$rc.enumObject('integration_document_type', document_type)?.text;
        },

        onClickViewChunkDetail(item)
        {
            this.$router.push({
                'name': 'integration-sync-history-one-batch',
                'params' : {
                    'organization_id': this.$route.params.organization_id,
                    'settings_id': this.$route.params.settings_id,
                    'sync_batch_id': item.sync_batch_id,
                }
            });
        },
            
        onRefresh()
        {
            this.doUpdate();
        },

        onClickExport()
        {
            this.$rc.alert('TODO: Excel export');
        }
    },

    computed: {
        title()
        {
            let content_type = this.results
                .map(item => item.content_type)
                .at(0);

            let content_type_desc = content_type ? this.$rc.pretty(content_type, 'integration_name') : "Integration";

            return content_type_desc + ' Sync History';
        }
    }
}
</script>

<style lang="scss" scoped>
</style>